// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav-module--nav--L7246","link":"nav-module--link--3vYnh","altBorder":"nav-module--altBorder--1Zh5-"};